import { render, staticRenderFns } from "./SendPageAccess.vue?vue&type=template&id=11791368&"
import script from "./SendPageAccess.vue?vue&type=script&lang=ts&"
export * from "./SendPageAccess.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports